import type { ListProps } from "./ListProps"
import { Ripple } from "../Ripple"
import { useListFunctions } from "../../hooks/useListFunctions"
import { getRippleColorFromColorStyle, getTrue } from "../../utils"
import cx from "classix"

import listStyle from "./index.module.css"
import { use } from "react"
import { FieldsetContext } from "~/shared/ui/kit/components/Fieldset"

export type { ListProps }

/**
 * Список с выбором
 */
export const List = function List<C>({
										 name,
										 items = [],
										 borderless = false,
										 colorStyle = "primary",
										 valueIsIndex = false,
										 valueProp = "value",
										 contentProp = "content",
										 selectableProp = getTrue,
										 value,
										 disabled = false,
										 onChange,
										 style,
										 className,
										 itemContainerStyle,
										 itemContainerClassName,
										 ...props
									 }: ListProps<C>) {

	const fs = use(FieldsetContext)
	const isDisabled = disabled || fs.disabled

	const {
		getContent,
		getValue,
		isSelectable
	} = useListFunctions<C>(contentProp, valueProp, selectableProp, valueIsIndex)

	return (
		<>
			<ul {...props} style={style}
				className={cx(listStyle.list,
					borderless && listStyle.borderless,
					isDisabled && listStyle.disabled,
					className)}>
				{
					items.map((item, index) => {

						const curValue = getValue(item, index)

						return <li
							key={curValue}
							onClick={onChange && isSelectable(item, index)
								? () => onChange(curValue, item, index)
								: undefined}
							className={cx(`cs-${colorStyle}`, (curValue === value) && listStyle.selected, itemContainerClassName)}
							style={itemContainerStyle}
						>
							<Ripple color={getRippleColorFromColorStyle(colorStyle)} />
							{getContent(item, index)}
						</li>
					})
				}
			</ul>
			<input type="hidden" name={name} value={value} />
		</>
	)
}

List.displayName = "List"